import React, { useState, useEffect } from "react";
import "./scroll-up.scss";
import arrowUp from "../../assets/img/icons/arrow-up.svg";

const ScrollUp: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      setIsVisible(scrollY > viewportHeight);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      role="button"
      className={`scroll-to-top-button ${isVisible ? "fadeOut" : ""}`}
      onClick={scrollToTop}
    >
      <img src={arrowUp} className="arrow" alt="Scroll to top" />
    </button>
  );
};

export default ScrollUp;
